import React from "react";
import "./receipt.css";
const Receipt = () => {
  const receiptData = JSON.parse(localStorage.getItem("receiptData"));
  if (!receiptData) {
    return <div>No receipt data available</div>;
  }
  const printReceipt = () => {
    window.print();
  };
  return (
    <div className="recepit-container">
      <div className="receipt-wrapper">
        <div className="receipt-inner">
          <div className="d-flex align-items-center mb-2">
            <div className="logo col-4">
              <img
                src="../assets/img/lims_logo.png"
                alt="Lims"
                width={140}
                height={90}
              />
            </div>
            <div className="receipt-header-unique col-8 d-flex justify-content-between align-items-center">
              Estimate Receipt
            </div>
          </div>
          <div className="ms-3 mt-3">
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Panel: <span>{receiptData?.company_name?.value || "N/A"}</span>
              </div>
            </div>
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Address: <span>{receiptData?.address || ""}</span>
              </div>
            </div>
          </div>
          <div className="receipt-row receipt-bttm-border">
            <div className="receipt-row-1 receipt-colheaders receipt24 ">
              Particulars
            </div>
            <div className="receipt-row-2 receipt-colheaders gap-2 receipt24">
              <div className="col-md-6">Item Code</div>
              <div className="col-md-6">Amount</div>
            </div>
          </div>
          <div className="receipt-row receipt-bttm-border">
            <div className="receipt-row-1">
              {receiptData?.investigation_name?.value || "N/A"}
            </div>
            <div className="receipt-row-2">
              <div className="col-md-6">{receiptData?.test_code || ""}</div>
              <div className="col-md-6">
                {receiptData?.investigtion_details[0]?.mrp || "0"}
              </div>
            </div>
          </div>
          <div className="receipt-bttm-border">
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1  receipt-total-lbl ">Total</div>
              <div className="receipt-row-2 ">
                {receiptData?.investigtion_details[0]?.mrp || "0"}
              </div>
            </div>
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1  receipt-total-lbl">Discount</div>
              <div className="receipt-row-2">
                {receiptData?.discount || "0"}
              </div>
            </div>
          </div>
          <div className="receipt-bttm-border ">
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1 receipt-total-lbl">NetAmt</div>
              <div className="receipt-row-2 receipt-black receipt16">
                {receiptData?.total_net || "0"}
              </div>
            </div>
          </div>
          <div className="d-flex flex-row">
            <div className="col-md-8">
              <div>
                <p>(Full Payment Before Investigation)</p>
                Printed By: <span>{receiptData?.printed_by || ""}</span>
              </div>
            </div>
            <div className="col-md-4  d-flex justify-content-end align-items-end">
              <div className="w-75 ">
                <hr
                  style={{ border: "1px solid dashed  black", width: "75%" }}
                />
                <div className="receipt-row ms-3 ps-3">
                  <p>Signature</p>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-primary"
              onClick={printReceipt}
            >
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Receipt;
